// File for logic corresponding to weather-tabs component
import { Component } from 'js-component-framework';
import { AriaTablist } from 'js-component-framework/lib/plugins';
import './weather-tabs.scss';

/**
 * Component for weather-tabs
 */
export default class WeatherTabs extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    const { tabselect } = this.children;
    this.onTabSelectChange = this.onTabSelectChange.bind(this);

    this.tablist = new AriaTablist({
      tablist: this.children.tablist,
      panels: this.children.panels,
    });
    this.tablist.init();

    if (tabselect) {
      tabselect.addEventListener('change', this.onTabSelectChange);
    }

    this.element.classList.add('weather-tabs--is-loaded');
  }

  /**
   * Stuff to do on select change.
   */
  onTabSelectChange() {
    const {
      tabselect,
      tablist,
      panels,
    } = this.children;
    const newIndex = tabselect.selectedIndex;
    const deactivate = {};
    const activate = {};

    deactivate.tab = tablist.querySelector('[aria-selected="true"]');
    const currentIndex = this.tablist.tabs.indexOf(deactivate.tab);
    deactivate.panel = panels[currentIndex];

    activate.index = newIndex;
    activate.tab = this.tablist.tabs[newIndex];
    activate.panel = panels[newIndex];

    this.tablist.updateTabs(deactivate, activate);
  }
}
